import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mx-5 my-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "my-3" }, "Test component", -1)
const _hoisted_5 = { class: "mb-5 flex items-center" }
const _hoisted_6 = { class: "mb-5 storybook-input" }
const _hoisted_7 = { class: "mb-5 storybook-input" }
const _hoisted_8 = { class: "mb-5 flex" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("connect device ")
const _hoisted_10 = { class: "mb-5 flex" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "text-2xl cp-icon-plus" }, null, -1)
const _hoisted_12 = { class: "flex w-1/2" }
const _hoisted_13 = { class: "mb-6" }
const _hoisted_14 = { class: "truncate w-100 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Input = _resolveComponent("Input")
  const _component_InputSearch = _resolveComponent("InputSearch")
  const _component_Button = _resolveComponent("Button")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Switch = _resolveComponent("Switch")
  const _component_DatePickerInput = _resolveComponent("DatePickerInput")
  const _component_YearInput = _resolveComponent("YearInput")
  const _component_Table = _resolveComponent("Table")
  const _component_Paging = _resolveComponent("Paging")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_1, "...loading"))
      : (_ctx.sample)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sample, (item) => {
              return (_openBlock(), _createBlock("div", {
                key: item.id
              }, " title: " + _toDisplayString(item.title) + " content: " + _toDisplayString(item.content), 1))
            }), 128)),
            _withDirectives(_createVNode("input", {
              type: "text",
              placeholder: "title",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.title = $event))
            }, null, 512), [
              [_vModelText, _ctx.title]
            ]),
            _withDirectives(_createVNode("input", {
              type: "text",
              placeholder: "content",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.content = $event))
            }, null, 512), [
              [_vModelText, _ctx.content]
            ]),
            _createVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addSample && _ctx.addSample(...args))),
              disabled: _ctx.title === '' || _ctx.content === ''
            }, _toDisplayString(_ctx.t('add')), 9, ["disabled"]),
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_Avatar, {
                  name: "片山",
                  id: "9800d59b-50ba-11eb-b45b-0242c0a89002",
                  size: "small"
                }),
                _createVNode(_component_Avatar, {
                  name: "片山",
                  id: "9800d59b-50ba-11eb-b45b-0242c0a89002"
                }),
                _createVNode(_component_Avatar, {
                  name: "片山",
                  id: "9800d59b-50ba-11eb-b45b-0242c0a89002",
                  size: "large"
                })
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_Input, {
                  placeholder: "placeholder",
                  label: "タイトル",
                  "sub-label": "ヘルパーテキスト",
                  readonly: false,
                  modelValue: _ctx.text,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.text = $event)),
                  noteMessage: "ノート",
                  isRequiredLabel: true,
                  required: true,
                  validated: _ctx.validated
                }, null, 8, ["modelValue", "validated"])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_InputSearch, {
                  placeholder: "placeholder",
                  readonly: false,
                  modelValue: _ctx.listEmployee,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.listEmployee = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_Button, {
                  class: "mx-2",
                  onClick: _ctx.connect
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  class: "w-20 mx-2",
                  variant: "secondary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  class: "w-20 mx-2",
                  variant: "warning",
                  size: "large",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  class: "w-20 mx-2",
                  variant: "success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  class: "w-20 mx-2",
                  variant: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  class: "w-20 mx-2",
                  variant: "info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_Button, {
                  class: "mx-2",
                  variant: "outline-primary",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.t('search')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  class: "w-20 mx-2",
                  variant: "outline-secondary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  class: "w-20 mx-2",
                  variant: "outline-warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  class: "w-20 mx-2",
                  variant: "outline-success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  class: "w-20 mx-2",
                  variant: "outline-danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  class: "w-20 mx-2",
                  variant: "outline-info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('search')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_Dropdown, {
                "options-select": [1, 2, 3, 4],
                modelValue: _ctx.selected,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selected = $event)),
                class: "mr-6",
                required: "",
                validated: _ctx.validated
              }, null, 8, ["modelValue", "validated"]),
              _createVNode(_component_MultiSelect, {
                options: [1, 2, 3, 4],
                modelValue: _ctx.selected,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selected = $event)),
                class: "w-50"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_Switch, {
                modelValue: _ctx.switchVal,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.switchVal = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_Button, {
              label: "success",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showToast('success', 'success')))
            }),
            _createVNode(_component_Button, {
              label: "warning",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showToast('warning', 'warning')))
            }),
            _createVNode(_component_Button, {
              label: "error",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showToast('error', 'error')))
            }),
            _createVNode(_component_Button, {
              label: "info",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showToast('info', 'info')))
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.date) + " " + _toDisplayString(_ctx.month) + " " + _toDisplayString(_ctx.year) + " ", 1),
            _createVNode(_component_DatePickerInput, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.date = $event)),
              "is-icon-chevron-left": "",
              "is-icon-chevron-right": "",
              isFixed: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_DatePickerInput, {
              modelValue: _ctx.month,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.month = $event)),
              type: "month",
              "is-icon-chevron-left": "",
              "is-icon-chevron-right": "",
              format: "YYYY/MM"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_YearInput, {
              modelValue: _ctx.year,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.year = $event)),
              width: "120",
              isShowChevron: ""
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
    _createVNode("div", null, [
      _createVNode(_component_Table, {
        headers: _ctx.optionStampingHeader,
        data: [..._ctx.dataTable],
        itemsPerPages: 5,
        recordTotal: 15,
        fixedLeft: 2,
        isFixed: true,
        currentPage: _ctx.currentPage,
        "onUpdate:currentPage": _cache[18] || (_cache[18] = ($event: any) => (_ctx.currentPage = $event))
      }, {
        check_in: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_14, _toDisplayString(item.text), 1)
        ]),
        "data-check_in": _withCtx(({ index }) => [
          _createVNode(_component_Dropdown, {
            "options-select": [1, 2, 3, 4],
            modelValue: _ctx.selected,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.selected = $event)),
            class: "w-100",
            isFixed: true,
            heightToAlwayBot: (index + 1) * 48
          }, null, 8, ["modelValue", "heightToAlwayBot"])
        ]),
        "data-break_end": _withCtx(({ index }) => [
          _createVNode(_component_DatePickerInput, {
            modelValue: _ctx.date,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.date = $event)),
            class: "w-100",
            isFixed: true,
            heightToAlwayBot: (index + 1) * 48
          }, null, 8, ["modelValue", "heightToAlwayBot"])
        ]),
        _: 1
      }, 8, ["headers", "data", "currentPage"]),
      _createVNode(_component_Paging, {
        totalItem: 101,
        pageActive: _ctx.pageActive,
        "onUpdate:pageActive": _cache[19] || (_cache[19] = ($event: any) => (_ctx.pageActive = $event))
      }, null, 8, ["pageActive"])
    ])
  ], 64))
}